<template>
  <div class="spe_list">
    <span :class="{ 'select': isNoChoose, 'w50': isW50 }" @click="handleNoChoose" v-if="limit">
      不限<img :src="mulIcon" />
    </span>
    <span v-for="(el, j) in list" :key="j" :class="{ 'select': curSelect(el), 'w50': isW50 }" @click="clickItem(el)">
      {{el.name}}<img :src="mulIcon" />
    </span>
  </div>
</template>

<script>
import mulIcon from '@/assets/multiple_select.png'
export default {
  name: 'SpeGroup',
  props: {
    list: Array, isMuilt: Boolean, value: Array, limit: Boolean
  },
  data () {
    return {
      mulIcon, result: []
    }
  },
  computed: {
    isNoChoose () {
      return this.result.length == 0
    },
    curSelect () {
      return el => {
        return this.result.length && this.resultLabelValue.indexOf(el.labelValue) > -1
      }
    },
    resultLabelValue () {
      return this.result.map(el => el.labelValue)
    },
    isW50 () {
      if (this.list.length) {
        return this.list[0].typeName == '行为'
      }
      return false
    }
  },
  watch: {
    value: {
      immediate: true,
      handler (v) {
        this.result = v && v.length ? v : []
      }
    }
  },
  methods: {
    clickItem (el) { // 点击切换选中状态
      let isMuilt = this.isMuilt // 是否多选
      let elInResIdx = this.resultLabelValue.indexOf(el.labelValue)
      let isChoose = elInResIdx == -1 // 当前el是否是选中的状态 -1位未选中
      if (isMuilt) {
        if (isChoose) this.result.push(el)
        else this.result.splice(elInResIdx, 1)
      } else {
        if (isChoose) this.result = [el]
        else this.result = []
      }
      this.chooseChange()
      this.$forceUpdate()
    },
    handleNoChoose () {
      this.result = []
      this.chooseChange()
      this.$forceUpdate()
    },
    chooseChange () {
      let v = this.result
      this.$emit('input', v)
      this.$emit('distChange', v)
    }
  }
}
</script>

<style lang="scss" scoped>
.spe_list {
  margin-bottom: 20px;
  span {
    display: inline-block;
    position: relative;
    min-width: 120px;
    padding: 0 7px;
    line-height: 30px;
    border: 1px solid #E9E9E9;
    margin: 5px;
    font-size: 12px;
    cursor: pointer;
    text-align: center;
    &.w50 {
      min-width: 50px;
    }
    img {
      display: none;
      position: absolute;
      top: 0;
      right: 0;
    }
    &.select {
      border-color: #282729;
      img {
        display: block;
      }
    }
  }
}
// .spe {
//   border: 1px solid #e9e9e9;
//   min-height: 38px;
//   position: relative;
//   border-radius: 4px;
//   > label {
//     font-weight: 600;
//     position: absolute;
//     left: 20px;
//     top: 50%;
//     margin-top: -10px;
//     z-index: 1;
//     padding-right: 10px;
//     border-right: 1px solid #e9e9e9;
//   }
//   .el-select__tags {
//     padding-left: 100px;
//     .el-tag--info.el-tag--mini {
//       background-color: #f0f2f5;
//       border-color: transparent;
//       margin: 2px 2px 2px 0;
//     }
//     .el-tag__close.el-icon-close {
//       background-color: #c0c4cc;
//       right: -7px;
//       top: 0;
//       color: #fff;
//     }
//   }
// }
</style>
